import { ShieldWarning } from "@phosphor-icons/react";
import "./access.css";

export const SENSITIVE_DATA_NOTICE_TEXT =
  "שים/י לב: הרשאה זו חושפת דוחות טיפול והערות קליניות, שעשויים להכיל מידע רפואי רגיש. ודא/י שהמטפל/ת מורשה/ית לצפות בו לפי נהלי הקליניקה. כל צפייה בדוח של מטפל/ת אחר/ת נרשמת ביומן.";

/** Shown to ADMINS next to any ⚠⚠ (medical) permission toggle. */
function SensitiveDataNotice({ text = SENSITIVE_DATA_NOTICE_TEXT, compact = false }) {
  return (
    <div className={`ck-sensitive-notice ${compact ? "compact" : ""}`} role="note">
      <ShieldWarning size={compact ? 14 : 18} weight="fill" />
      <span>{text}</span>
    </div>
  );
}

export default SensitiveDataNotice;
